import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableHead, TableRow, Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

    render() {
        const reportData = this.props.reportData;
        const totalValues = this.props.totalValues;

        return (
            <div>
                <h3><center><u>Cultivation Efficiency Against Target Annual Plan for FCC</u></center></h3>
                <Box display="flex" justifyContent="center" p={2} style={{ maxWidth: '120%', overflowX: 'auto' }}   >
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>Date Range </TableCell>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>Collection Center</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>SKU Code</TableCell>
                                <TableCell align="left" style={{ fontWeight: "bold" }}>SKU Description</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Annual Target Plan | Demand Forecasting</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Cultivated Quantity</TableCell>
                                <TableCell align="right" style={{ fontWeight: "bold" }}>Supplied Quantity</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(() => {
                                const grouped = {};
                                reportData.forEach((row) => {
                                    const key = `${row.weekStartDate}-${row.weekEndDate}-${row.skuCode}-${row.skuDescription}-${row.demandForecasting}`;
                                    if (!grouped[key]) grouped[key] = [];
                                    grouped[key].push(row);
                                });

                                const rows = [];

                                Object.entries(grouped).forEach(([key, group]) => {
                                    group.forEach((row, index) => {
                                        rows.push(
                                            <TableRow key={`${key}-${index}`}>
                                                {/* Date Range */}
                                                <TableCell align="left" style={{ whiteSpace: 'nowrap' }}>
                                                    {row.weekStartDate && row.weekEndDate && new Date(row.weekStartDate).getFullYear() > 1900
                                                        ? `${new Date(row.weekStartDate).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: '2-digit',
                                                            day: '2-digit',
                                                        })} - ${new Date(row.weekEndDate).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: '2-digit',
                                                            day: '2-digit',
                                                        })}`
                                                        : '-'}
                                                </TableCell>
                                                <TableCell align="left">{row.factoryName}</TableCell>
                                                <TableCell align="left">{row.skuCode}</TableCell>
                                                <TableCell align="left">{row.skuDescription}</TableCell>
                                                {index === 0 && (
                                                    <TableCell
                                                        align="right"
                                                        rowSpan={group.length}
                                                        style={{
                                                            verticalAlign: 'middle',
                                                        }}
                                                    >
                                                        {row.demandForecasting == null || row.demandForecasting === 0
                                                            ? '-'
                                                            : parseFloat(row.demandForecasting).toLocaleString('en-US', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2,
                                                            })}
                                                    </TableCell>
                                                )}
                                                <TableCell align="right">
                                                    {row.cultivatedQty == 0
                                                        ? '-'
                                                        : parseFloat(row.cultivatedQty).toLocaleString('en-US', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                </TableCell>
                                                <TableCell align="right">
                                                    {row.netAmount == 0
                                                        ? '-'
                                                        : parseFloat(row.netAmount).toLocaleString('en-US', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        })}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    });
                                });
                                return rows;
                            })()}
                        </TableBody>
                        <TableRow>
                            <TableCell colSpan={4} align={'left'} style={{ fontWeight: 'bold' }}>Total</TableCell>
                            <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                {totalValues.totalDemand == 0 ? '-' : parseFloat(totalValues.totalDemand).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                {totalValues.totalCultivate == 0 ? '-' : parseFloat(totalValues.totalCultivate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                            <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                {totalValues.totalSupply == 0 ? '-' : parseFloat(totalValues.totalSupply).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </TableCell>
                        </TableRow>
                    </Table>
                </Box>
                <hr />
            </div>
        );
    }
}
